const Show = (props) => (props.condition ? props.children : null);
export default Show;